<template>
  <span class="d-inline-flex align-items-center gap-1 flex-wrap">
    <!-- Status badge -->
    <span :class="badgeClass" :aria-label="displayLabel">
      <span v-if="inQueue" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
      {{ displayLabel }}
    </span>

    <!-- Submission fraction / no required subtasks -->
    <span
      v-if="totalRequired === 0"
      class="badge bg-secondary-subtle text-muted border"
    >No required subtasks</span>
    <span
      v-else
      class="badge bg-light text-dark border"
      :title="`${submittedCount} of ${totalRequired} required subtasks submitted`"
    >
      {{ submittedCount }}/{{ totalRequired }}
    </span>

    <!-- Nearest deadline countdown -->
    <small v-if="daysUntil > 0" class="text-muted">
      {{ daysUntil }}d to {{ deadlineLabel }}
    </small>
  </span>
</template>

<script>
const STATUS_CONFIG = {
  unreleased: { cls: 'badge bg-primary ms-2',            label: 'Unreleased' },
  open:       { cls: 'badge bg-warning text-dark ms-2',  label: 'Open'       },
  passed:     { cls: 'badge bg-success ms-2',             label: 'Passed'     },
  failed:     { cls: 'badge bg-danger ms-2',              label: 'Failed'     },
  closed:     { cls: 'badge bg-secondary ms-2',           label: 'Closed'     },
};

const DEADLINE_LABELS = {
  pre:        'pre-evaluation',
  submission: 'submission',
  post:       'post-evaluation',
  manual:     'manual deadline',
};

export default {
  name: 'HomeworkStatusBadges',
  props: {
    hwStatus:            { type: String,  default: 'closed' },
    inQueue:             { type: Boolean, default: false    },
    submittedCount:      { type: Number,  default: 0        },
    totalRequired:       { type: Number,  default: 0        },
    nearestDeadline:     { type: String,  default: null     },
    nearestDeadlineType: { type: String,  default: null     },
  },
  computed: {
    badgeClass() {
      if (this.inQueue) return 'badge bg-info text-dark ms-2';
      return (STATUS_CONFIG[this.hwStatus] || STATUS_CONFIG.closed).cls;
    },
    displayLabel() {
      if (this.inQueue) return 'Evaluating';
      return (STATUS_CONFIG[this.hwStatus] || STATUS_CONFIG.closed).label;
    },
    daysUntil() {
      if (!this.nearestDeadline) return 0;
      return Math.ceil((new Date(this.nearestDeadline) - new Date()) / (1000 * 60 * 60 * 24));
    },
    deadlineLabel() {
      return DEADLINE_LABELS[this.nearestDeadlineType] || this.nearestDeadlineType || 'deadline';
    },
  },
};
</script>
